<template>
  <v-card flat>
    <div class="main-container">
      <v-content class="page">
        <v-toolbar class="elevation-0">
          <v-btn icon @click="goToRouteByName('Home')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <!--<v-toolbar-title>Club Lentes</v-toolbar-title>-->
        </v-toolbar>
        <notification-popup ref="popup"></notification-popup>
        <router-view @notificationPopup="showNotification" />
      </v-content>
      <v-card flat tile>
        <v-footer class="transparent-footer" padless>
          <content-footer></content-footer>
        </v-footer>
      </v-card>
    </div>
  </v-card>
</template>
<script>
import NotificationPopup from '@/components/Shared/NotificationPopup'
import ContentFooter from '@/layouts/Store/ContentFooter'
import navigationMixin from '@/mixins/navigation'

export default {
  mixins: [navigationMixin],
  components: {
    NotificationPopup,
    ContentFooter
  },
  methods: {
    showNotification (notification) {
      this.$refs.popup.show(notification)
    }
  }
}
</script>
<style scoped>
.main-container {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.page {
  flex: 1;
  background-color: #FFFFFF;
  /*align-items: center;*/
}
.transparent-footer {
  background: transparent;
}
.container {
  padding: 0;
}
</style>
